/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiExcelExcelPayrollWorkedDaysGet$Params {
  date1?: string;
  date2?: string;
  clientID?: string;
}

export function apiExcelExcelPayrollWorkedDaysGet(http: HttpClient, rootUrl: string, params?: ApiExcelExcelPayrollWorkedDaysGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, apiExcelExcelPayrollWorkedDaysGet.PATH, 'get');
  if (params) {
    rb.query('date1', params.date1, {});
    rb.query('date2', params.date2, {});
    rb.query('clientID', params.clientID, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

apiExcelExcelPayrollWorkedDaysGet.PATH = '/api/Excel/Excel_PayrollWorkedDays';
